// Narrative memory — the run's flags (Order 16.6, consuming the design rule in
// arcade_playable_cinema_v0: "let the graph breathe; carry consequence in state,
// never in duplicated scenes").
//
// A flag is a named fact a beat or an exit sets and a guard reads: 'met-woman',
// 'took-the-door'. Deliberately a flat Set of strings — the story graph needs a
// handful of remembered choices, not a save system. Module-level, so it survives
// Phaser scene restarts (a location transition) and dies with the page (a run).
// Scoping beyond per-run (persistent saves) is an open question in canon and is
// NOT this module's business.

const flags = new Set<string>();

/** Record a fact. Idempotent. */
export function setFlag(name: string): void {
  flags.add(name);
}

export function hasFlag(name: string): boolean {
  return flags.has(name);
}

/** Every flag set this run — for the debug overlay and the report, not logic. */
export function flagsSnapshot(): string[] {
  return [...flags].sort();
}

/** A new run. Nothing calls this yet (a run is a page load); a future
 *  restart/death flow will. */
export function resetStory(): void {
  flags.clear();
}
